import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import './floatingCTA.css';

export default function FloatingCTA(){
  const [open, setOpen] = useState(false);
  return (
    <div className={"floating-cta" + (open? ' open':'')}>
      <button className="fab" onClick={()=>setOpen(o=>!o)} aria-label="Angebot anfragen">{open? '✕':'✉️'}</button>
      <div className="panel">
        <h4>Blitz-Anfrage</h4>
        <p>Kurz: Personen & Wunschpaket — wir senden ein Angebot.</p>
        <Link className="btn" to="/kontakt">Zur Anfrage</Link>
      </div>
    </div>
  );
}
